import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const getRemoveReservedAccountNo = async (id: number): Promise<boolean> =>
  axios.get(`/accountreservation/removereservedaccount?reserveId=${id}`).then((res) => res.data?.result)

type Props = {
  id: number
}

export const useRemoveReservedAccountNo = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['getRemoveReservedAccountNo'],
    mutationFn: ({ id }: Props) => getRemoveReservedAccountNo(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created device activation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create device activation, please try again.')
      }
    },
    throwOnError: false
  })
